import yup from "@/yup";

export function useHallSettingsFormSchema() {
  return yup.object({
    password: yup
      .string()
      .min(6)
      .transform((value) => (!value ? undefined : value)),
    isBalanceUnlimited: yup.boolean(),
    isConvActive: yup.boolean(),
    isBlocked: yup.boolean(),
    isPanicBlock: yup.boolean(),
    autoPrintReceipts: yup.boolean(),
    lobbySettings: yup
      .object({
        isPanicEnabled: yup.boolean(),
        panicUrl: yup.string().url(),
      })
      .optional()
      .transform((value) => {
        if (!value) {
          return value;
        }
        return Object.keys(value).length === 0 ? undefined : value;
      })
      .default(undefined),
    configuredByParent: yup.boolean(),
    gameDisplayType: yup
      .mixed()
      .oneOf(["always", "kyc_confirmed", "kyc_confirmed_or_deposit", null]),
    kycType: yup.mixed().oneOf(["manual", "provider", null]),
  });
}

export type HallSettingsFormSchema = yup.InferType<
  ReturnType<typeof useHallSettingsFormSchema>
>;
